<template>
    <div class="tags stycky-btn" @click="toggle()" @blur="toggle()">
        <span class="tag sticky-tag is-rounded-right is-size-3" :class="{'is-large': isOpen, '': !isOpen }">
            <i :class="classObj" class="fa-lg"></i>
            <span class="is-size-3 tag-text" :class="{'is-hidden': !isOpen, 'animated fadeInLeft ': isOpen }"> {{ label }}</span>
        </span>
        <ul :class="{'is-hidden animated fadeOutLeft': !isOpen, 'animated fadeInLeft ': isOpen }">
            <li  v-for="item in items" :key="item.id">
                <a v-if="type==='link'" :href="item.url" target="_blank">
                    {{ item.name }}
                </a>
                <a v-else :href="route + item.slug" @click.native="getItems(item.slug)">
                    {{ item.name }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ApiHome } from '../../.env';

export default {
    props: ['label', 'items', 'route', 'type'],

    data() {
        return {
            isOpen: false,
            endpoint: ApiHome+ 'posts',
            iclass: 'tag'
        }
    },

    computed: {
        ...mapGetters([
            'posts',
            'postsCategories',
            'loading',
            'error',
            'title',
        ]),
        classObj() {
            if(this.type === 'link') {
                this.iclass = 'link';
            }
            return 'fa fa-' + this.iclass;
            // console.log('class obj ', this.type, this.iclass);
        }
    },

    methods: {
        toggle() {
            this.isOpen = !this.isOpen
        },

        // Trigger load new data on button click
        getItems(item) {
            // handle data and give it back to parent by interface
            this.$emit('getItem', item)
        },
    },

    created() {
        // document.title = this.capitalize(this.photo);
        // console.log('Sticky Button - Component mounted.')
    }
}
</script>


<style lang="scss">

@import "../../style/app.scss";

.stycky-btn{
    margin: 5px 0 0 50px;
    z-index:100;
    cursor: pointer;
    transition: all .2s ease-in-out;
    &:first-child{
        top: 35%;
    }
    .is-rounded-right {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        border-bottom-right-radius: 290486px;
        border-top-right-radius: 290486px;
        height: 50px;
        padding: 20px 30px;
        font-size: 2rem;
        border: 4px solid $th-black-05;
    }
    ul {
        display: block;
        width: 100%;
        clear: both;
        // padding: 30px 0;
        line-height: 1.5;
        font-size: 1.5rem;
        // margin: -10px 0 0 -60px;
        z-index: 101;
        background: $white;
        position: absolute;
        top: 50px;
        left:0;
        padding: 10px 0;
        li {
            text-transform: capitalize;
            a {
                padding: 0.3rem 3rem;
                color: $th-black-05;
                display: inline-block;
                margin-bottom: 5px;
                box-shadow: 0px 2px 0 0 rgba(0,0,0,0.1);
                &:hover{
                    transition: 0.15s padding ease-out;
                    color: $limegreen;
                }
            }
        }
    }
    &.is-large {
        padding: 20px 60px;
    }
    .tag-text {
        padding-left: 20px;
    }
    .sticky-tag {
        color: $th-black-05 !important;
    }
    .tag:not(body) {
        background-color: transparent;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/StickyButton.vue